import DefaultMonitor from "./default";

class ElementMonitor extends DefaultMonitor {
    _element: HTMLElement;
    _height: number;

    get scrollTop(): number {
        return this._element ? this._element.scrollTop : 0;
    }

    get scrollLeft(): number {
        return this._element ? this._element.scrollLeft : 0;
    }

    watch(element: HTMLElement): void {
        super.watch(element);
        this._height = this._element.getBoundingClientRect().height;
        this._element.addEventListener("scroll", this.handleScroll, false);
    }

    unwatch(): void {
        super.unwatch();
        if (this._element) {
            this._element.removeEventListener("scroll", this.handleScroll, false);
        }
    }

    isNearBottom(): boolean {
        return this._element.scrollTop + this._height > this.layoutManager.runwayLength - 400;
    }

    handleViewportChange(): void {
        const { layoutManager } = this;
        if (this._element) {
            const { width, height } = this._element.getBoundingClientRect();
            layoutManager.setViewportDimensions(width, height, 0);
        }
    }
}

export default ElementMonitor;
